var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 22.918H22.916V16.043L14.8952 8.02213C17.461 6.79671 20.3436 6.39689 23.1461 6.87772C25.9486 7.35855 28.533 8.69638 30.5437 10.707C32.5543 12.7176 33.8921 15.3021 34.3729 18.1045C34.8537 20.907 34.4539 23.7896 33.2285 26.3555L46.9785 40.1055C47.8902 41.0171 48.4024 42.2536 48.4024 43.543C48.4024 44.8323 47.8902 46.0688 46.9785 46.9805C46.0668 47.8921 44.8303 48.4043 43.541 48.4043C42.2517 48.4043 41.0152 47.8921 40.1035 46.9805L26.3535 33.2305C23.7877 34.4559 20.9051 34.8557 18.1026 34.3749C15.3001 33.894 12.7156 32.5562 10.705 30.5456C8.69442 28.535 7.35659 25.9505 6.87577 23.148C6.39494 20.3456 6.79476 17.4629 8.02017 14.8971L16.041 22.918Z",
    stroke: "#199CB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon);
export default __webpack_public_path__ + "static/media/tool-icon.1c4ae4cd765350157e8105a3799e7754.svg";
export { ForwardRef as ReactComponent };